import { AppConfig } from '@/config/types';
import { InitEnviromentMethod, initEnviromentAsync } from '@gd/enviroment';
import axios from 'axios';

const envs = {
  QuestionBankAPI: '',
  FinancialAPI: '',
  AuthorityAPI: '',
  OperateAPI: '',
  FileServerAPI: '',
  LoggerAPI: '',
  MarketAPI: '',
  EducationalAPI: '',
  StudyingAbroadAPI: '',
  ArticleServerAPI: '',
  CoursewareAPI: '',
  BaseDataAPI: '',
};

const config: AppConfig = {
  SystemCode: 'ManagementSystem',
  BaseURL: 'https://gateway.xmjriyu.com',
  ServerHost: 'https://oaapi.xmjriyu.com',
  DateTimeFormat: 'YYYY-MM-DDTHH:mm:ss.SSS',
  QuestionTopicGateway: '',
  FinancialGateway: '',
  AuthorityGateway: '',
  OperateGateway: '',
  FileGateway: '',
  LogGateway: '',
  MarketGateway: '',
  EducationalGateway: '',
  StudyingAbroadGateway: '',
  ArticleGateway: '',
  CoursewareGateway: '',
  BaseDataGateway: '',
};

export function useConfig(): AppConfig {
  return config;
}

export async function initConfig() {
  await initEnviromentAsync(envs, getConfig, {
    NamespaceName: 'Application',
    ProjectName: 'XMJFrontendProject',
  });
  config.QuestionTopicGateway = envs.QuestionBankAPI;
  config.FinancialGateway = envs.FinancialAPI;
  config.AuthorityGateway = envs.AuthorityAPI;
  config.OperateGateway = envs.OperateAPI;
  config.FileGateway = envs.FileServerAPI;
  config.LogGateway = envs.LoggerAPI;
  config.MarketGateway = envs.MarketAPI;
  config.EducationalGateway = envs.EducationalAPI;
  config.StudyingAbroadGateway = envs.StudyingAbroadAPI;
  config.ArticleGateway = envs.ArticleServerAPI;
  config.CoursewareGateway = envs.CoursewareAPI;
  config.BaseDataGateway = envs.BaseDataAPI;
}

const getConfig: InitEnviromentMethod = (input) => {
  return new Promise((resolve, reject) => {
    axios
      .request({
        url: import.meta.env.VITE_ENVIRONMENT_URL,
        method: 'POST',
        data: input,
      })
      .then((res) => {
        if (res.status !== 200) {
          reject(new Error('请求失败'));
          return;
        }
        resolve(res.data);
      })
      .catch(reject);
  });
};
